module.exports = "<div mdbProgress [animate]=\"animate\" [max]=\"max\">\r\n  <mdb-bar [type]=\"type\" [value]=\"value\">\r\n    <ng-content></ng-content>\r\n  </mdb-bar>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/progressbars/progressbar.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/progressbars/progressbar.component.html
// module chunks = main